/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import unitlessNumbers from "./modules/unitlessNumbers"
import normalizeColor from "./modules/normalizeColor"
import { Value } from "./types"

const colorProps = {
  backgroundColor: true,
  borderColor: true,
  borderTopColor: true,
  borderRightColor: true,
  borderBottomColor: true,
  borderLeftColor: true,
  color: true,
  shadowColor: true,
  textDecorationColor: true,
  textShadowColor: true,
}

export default function normalizeValueWithProperty(
  value: Value,
  property?: string | number | null,
) {
  let returnValue = value
  if (
    (property == null || !unitlessNumbers[property]) &&
    typeof value === "number"
  ) {
    returnValue = `${value}px`
  } else if (property != null && colorProps[property]) {
    if (typeof value === "number" || typeof value === "string") {
      const color = normalizeColor(value)
      if (color) {
        returnValue = color
      }
    }
  }
  return returnValue
}
